import { Link } from "react-router-dom"
import { Col, Row } from "reactstrap"
import DotIcon from "../../pages/Finance/voucherEntry/dotsvg"
import arrow from "../../assets/icons/arrow.svg"
import { useSelector } from "react-redux"

const RenderSubmenu = ({ item, level = 0 }) => {
  // console.log(`item renderMenu`, item)

  const loggedUser = useSelector(state => state.Login.loggedUser)

  // console.log(`loggedUser render`, loggedUser);
  

  // const hasSubmenus = Array.isArray(item?.submenus) && item.submenus.length > 0

  // Permission check function
  const hasPermission = (menuItem) =>
    loggedUser?.permission?.some(
      (permissionItem) =>
        permissionItem?.id === menuItem?.id 
      // &&
      //   permissionItem?.is_menu == 1
    )

    // Filter submenus based on permission
    const permittedSubmenus = (item?.submenus || []).filter((dt) =>
      hasPermission(dt)
    )
  
    const hasPermittedSubmenus = permittedSubmenus.length > 0
  
    // If the current item is a leaf node and has no permission → skip rendering
    if (!hasPermittedSubmenus && !hasPermission(item)) {
      return null
    }
  

  return (
    <div className={`ps-${level * 3}`}>
      {hasPermittedSubmenus ? (
        <>
          <div className="sub-menu-title mb-2">{item?.label}</div>
          <Row>
            {permittedSubmenus?.map((sub, idx) => (
              <Col xs={12} key={sub?.id || `${item?.label}-${idx}`}>
                <RenderSubmenu item={sub} level={level + 1} />
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <Link to={item?.linkTo}>
          <div className="my-2 d-flex align-items-center">
            <span className="list-of-dashmenus">
              <DotIcon />
            </span>
            &nbsp;&nbsp;&nbsp;
            <label className="sub-menu-link mb-0" role="button">
              {item?.label}
            </label>
            <img src={arrow} alt="" width="7" className="ms-2" />
          </div>
        </Link>
      )}
    </div>
  )
}

export default RenderSubmenu
